import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal } from 'antd'
import {
  addOfficeTextableNumber,
  updatePhoneNumber,
  deletePhoneNumber,
} from '../../common/requests'
import PhoneNumberDetailsForm from './PhoneNumberDetailsForm'
import ExistingPhoneNumbersList from './ExistingPhoneNumbersList'

class AddAndEditPhoneNumberModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      editingPhoneNumberId: null,
      error: null,
      phoneNumberText: '',
      preferredNumber: false,
      selectedLocationIds: [props.locationId],
      twilioSid: '',
      willDelete: false,
    }
    this.handleAddPhoneNumber = this.handleAddPhoneNumber.bind(this)
    this.handleDeletePhoneNumber = this.handleDeletePhoneNumber.bind(this)
  }

  handleTextChange = e => this.setState({ [e.target.name]: e.target.value })

  handleCheck = ({ target: { checked } }) =>
    this.setState({ preferredNumber: checked })

  async handleAddPhoneNumber() {
    const {
      phoneNumberText,
      preferredNumber,
      selectedLocationIds,
      twilioSid,
    } = this.state
    const { refetchLocations, toggleModal, selectedBusinessId } = this.props
    if (
      !phoneNumberText.length ||
      !twilioSid.length ||
      !selectedLocationIds.length
    ) {
      return
    }
    try {
      await addOfficeTextableNumber(
        phoneNumberText,
        twilioSid,
        selectedLocationIds,
        preferredNumber,
        selectedBusinessId,
      )
      toggleModal(false, null)
      this.clearState()
      refetchLocations()
    } catch (error) {
      this.setState({ error: error.message })
    }
  }

  async handleUpdatePhoneNumber() {
    const {
      editingPhoneNumberId,
      preferredNumber,
      selectedLocationIds,
    } = this.state
    const { refetchLocations, toggleModal, selectedBusinessId } = this.props
    if (!editingPhoneNumberId || !selectedLocationIds.length) return
    try {
      await updatePhoneNumber(
        editingPhoneNumberId,
        preferredNumber,
        selectedBusinessId,
        selectedLocationIds,
      )
      toggleModal(false, null)
      this.clearState()
      refetchLocations()
    } catch (error) {
      this.setState({ error: error.message })
    }
  }

  async handleDeletePhoneNumber() {
    const { editingPhoneNumberId, willDelete } = this.state
    const { toggleModal, refetchLocations } = this.props
    if (willDelete) {
      try {
        await deletePhoneNumber(editingPhoneNumberId, this.props.locationId)
        this.clearState()
        toggleModal(false, null)
        refetchLocations()
      } catch (error) {
        this.setState({ error: error.message })
      }
    } else {
      this.setState({ willDelete: true })
    }
  }

  handleCancelDelete = () => {
    this.setState({ willDelete: false })
  }

  handleConfirm = () => {
    if (this.state.editingPhoneNumberId) {
      this.handleUpdatePhoneNumber()
    } else {
      this.handleAddPhoneNumber()
    }
  }

  handleCancel = () => {
    const { toggleModal } = this.props
    const { editingPhoneNumberId } = this.state
    this.clearState()
    if (!editingPhoneNumberId) {
      toggleModal(false, null)
    }
  }

  setEditingPhoneNumberId = (editingPhoneNumberId) => {
    this.setState({ editingPhoneNumberId })
    if (editingPhoneNumberId) {
      const {
        business_id: selectedBusinessId,
        is_preferred: preferredNumber,
        location_ids: selectedLocationIds,
        phone_number: phoneNumberText,
        twilio_sid: twilioSid,
      } = this.props.purchasedNumbers.find(number => number.id === editingPhoneNumberId)
      this.props.handleSelectedBusiness(selectedBusinessId)
      this.setState({
        phoneNumberText,
        preferredNumber,
        selectedLocationIds,
        twilioSid,
      })
    }
  }

  clearState = () => {
    this.setState({
      editingPhoneNumberId: null,
      error: null,
      phoneNumberText: '',
      selectedLocationIds: [this.props.locationId],
      twilioSid: '',
      willDelete: false,
    })
  }

  toggleLocation = ({ target: { checked, value: locationId } }) => {
    const { selectedLocationIds } = this.state
    if (checked) {
      this.setState({
        selectedLocationIds: [...selectedLocationIds, locationId],
      })
    } else {
      this.setState({
        selectedLocationIds: selectedLocationIds.filter(
          locId => locId !== locationId,
        ),
      })
    }
  }

  setModalTitle = () => {
    const { action } = this.props
    const { editingPhoneNumberId } = this.state
    if (action === 'edit' && !!editingPhoneNumberId) {
      return 'Edit Phone Number'
    }
    return action === 'edit'
      ? 'Add/Edit Phone Numbers'
      : 'Manually Add Phone Number'
  }

  render() {
    const {
      editingPhoneNumberId,
      error,
      phoneNumberText,
      preferredNumber,
      selectedLocationIds,
      twilioSid,
      willDelete,
    } = this.state
    const {
      action,
      businesses,
      countryCode,
      locations,
      open,
      purchasedNumbers,
      toggleModal,
      handleSelectedBusiness,
      selectedBusinessId,
    } = this.props
    const submitDisabled =
      !phoneNumberText.length ||
      !twilioSid.length ||
      !selectedLocationIds.length ||
      (!editingPhoneNumberId && action === 'edit')

    const footerButtons = [
      <Button key="cancel" onClick={this.handleCancel}>
        Cancel
      </Button>,
      <Button
        key="confirm"
        disabled={submitDisabled}
        onClick={this.handleConfirm}
      >
        Confirm
      </Button>,
    ]

    const modalTitle = this.setModalTitle()

    return (
      <Modal
        title={modalTitle}
        visible={open}
        footer={footerButtons}
        onCancel={this.handleCancel}
      >
        {action === 'edit' && !editingPhoneNumberId ? (
          <ExistingPhoneNumbersList
            toggleModal={toggleModal}
            purchasedNumbers={purchasedNumbers}
            setEditingPhoneNumberId={this.setEditingPhoneNumberId}
            countryCode={countryCode}
          />
        ) : (
          <PhoneNumberDetailsForm
            businesses={businesses}
            editingPhoneNumberId={editingPhoneNumberId}
            error={error}
            handleCancelDelete={this.handleCancelDelete}
            handleCheck={this.handleCheck}
            handleDelete={this.handleDeletePhoneNumber}
            handleSelectedBusiness={handleSelectedBusiness}
            handleTextChange={this.handleTextChange}
            locations={locations}
            phoneNumberText={phoneNumberText}
            preferredNumber={preferredNumber}
            purchasedNumbers={purchasedNumbers}
            selectedBusinessId={selectedBusinessId}
            selectedLocationIds={selectedLocationIds}
            setEditingPhoneNumberId={this.setEditingPhoneNumberId}
            toggleLocation={this.toggleLocation}
            twilioSid={twilioSid}
            willDelete={willDelete}
          />
        )}
      </Modal>
    )
  }
}

AddAndEditPhoneNumberModal.propTypes = {
  action: PropTypes.string,
  businesses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  countryCode: PropTypes.string.isRequired,
  locationId: PropTypes.string.isRequired,
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  open: PropTypes.bool.isRequired,
  refetchLocations: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
  handleSelectedBusiness: PropTypes.func.isRequired,
  selectedBusinessId: PropTypes.number,
}

AddAndEditPhoneNumberModal.defaultProps = {
  action: 'edit',
}

export default AddAndEditPhoneNumberModal



// WEBPACK FOOTER //
// ./src/AddPractice/Associations/AddAndEditPhoneNumberModal.js